import { ReactElement } from 'react'

import { LoadingIndicator } from '../../components/LoadingIndicator'

import * as styles from './styles.scss'

const RouteLoadingPlaceholder = (): ReactElement => {
    return (
        <div className={styles.background}>
            <LoadingIndicator size="small" />
        </div>
    )
}

export default RouteLoadingPlaceholder
